<template>
    <div>
        <div class="flex-con sm-pad-lr m-b-md">
            <div v-if="savedAddresses.length">
                <div class="select">
                    <select
                        :value="dealerAddress.id"
                        @input="change($event)"
                        :disabled="useShippingAddress"
                    >
                        <option :value="null">
                            Use New Address
                        </option>
                        <option
                            :value="a.id"
                            v-for="a in savedAddresses"
                            :key="a.id"
                        >
                            {{a.address.addressLine1}} <span v-if="a.address.addressessLine2">| {{a.address.addressessLine2}}</span>
                            | {{a.address.city}}, {{a.address.state}}
                        </option>
                    </select>
                </div>
            </div>
            <div v-if="dealerAddress.id">
                <a @click="deleteAddress">Delete</a>
            </div>
            <div v-if="!dealerAddress.id && isBilling">
                <div class="flex-con xs-pad-lr">
                    <div>
                        <div class="checkbox">
                            <input type="checkbox" :checked="useShippingAddress" @input="$emit('use-shipping', !useShippingAddress)"/>
                        </div>
                    </div>
                    <div>
                        Use Shipping Address
                    </div>
                </div>
            </div>
        </div>



        <div v-if="!useShippingAddress">
            <div v-if="!localValue.address.id">
                <edit-address v-model="localValue.address"/>
                <div class="flex-con xs-pad-lr">
                    <div class="checkbox">
                        <input type="checkbox" v-model="localValue.save"/>
                    </div>
                    <div>
                        Save For Future Use
                    </div>
                </div>
            </div>
            <div
                v-if="(isBilling && !dealerAddress.defaultBilling) || (!isBilling && !dealerAddress.defaultShipping)"
                class="flex-con xs-pad-lr m-t-sm"
            >
                <div class="checkbox">
                    <input type="checkbox" v-model="localValue.setDefault"/>
                </div>
                <div>
                    Set As Default
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Address from "../../orders/component/Address";
export default {
    components : {'edit-address' : Address},
    inject : ['$validator'],
    props : {
        value : {
            type : Object,
            required : true,
        },
        savedAddresses : {
            type : Array,
            required : true,
        },
        isBilling : {
            type : Boolean,
            required : false,
            default : false,
        },
        useShippingAddress : {
            type : Boolean,
            required : false,
            default : false,
        }
    },
    data () {
        return {
            dealerAddress : {},
        }
    },
    beforeMount () {
        //if they select same as shipping address and go to the final page and then come back we don't want to overwrite the choice
        if(this.useShippingAddress) {
            if(this.dealerAddress) {
                this.dealerAddress.id = null;
            }
            return;
        }
        if(this.isBilling) {
            if(this.defaultBilling) {
                this.dealerAddress = this.defaultBilling;
                this.localValue.address = this.defaultBilling.address;
            }
        } else if(this.defaultShipping) {
            this.dealerAddress = this.defaultShipping;
            this.localValue.address = this.defaultShipping.address;
        }
    },
    computed : {
        localValue : {
            get () {
                return this.value;
            },
            set (value) {
                this.$emit('input', value);
            },
        },
        defaultBilling () {
            return this.savedAddresses.find(a => a.defaultBilling);
        },
        defaultShipping () {
            return this.savedAddresses.find(a => a.defaultShipping);
        },
    },
    methods : {
        change ($event) {
            this.dealerAddress = this.savedAddresses.find(a => a.id === parseInt($event.target.value));
            if(!this.dealerAddress) {
                this.dealerAddress = {};
                this.localValue.address = { id : null };
            } else {
                this.localValue.address = this.dealerAddress.address;
            }
        },
        deleteAddress () {
            this.$emit('delete-address', this.dealerAddress);
            this.dealerAddress = {};
            this.localValue.address = { id : null };
        },
    }
}
</script>

<style scoped>

</style>
